import React from "react";
import SectionOne from "../../components/Body/SectionOne";
import SectionThree from "../../components/Body/SectionThree";
import SectionTwo from "../../components/Body/SectionTwo";

const Home = (props) => {
  const { openMod, modOpen, setMod, closeMod } = props;
  return (
    <div>
      <SectionOne
        modOpen={modOpen}
        setMod={setMod}
        openMod={openMod}
        closeMod={closeMod}
      />
      <SectionTwo
        modOpen={modOpen}
        setMod={setMod}
        openMod={openMod}
        closeMod={closeMod}
      />
      <SectionThree
        modOpen={modOpen}
        setMod={setMod}
        openMod={openMod}
        closeMod={closeMod}
      />
    </div>
  );
};

export default Home;
